define('../common/blocks/tariff/tariff',[],function() {
    (function() {
        function fixHref(href, from) {
            if (!from || (href && href.includes('%26from%3D'))) {
                return href;
            }
            var arr = href.split('%23');
            arr[0] = arr[0] + from;
            return arr.join('%23');
        }
        function addListeners($tariff) {
            var from = '';

            if (typeof URLSearchParams !== 'undefined') {
                let urlParams = new URLSearchParams(window.location.search);
                if (urlParams && urlParams.get('from') === 'cloud_direct') {
                    from = '%26from%3Dcloud_direct';
                }

                var bttns = document.querySelectorAll('a.tariff__button');
                bttns.forEach(function (el) {
                    el.href = fixHref(el.href, from);
                });
            }

            var $switch = $tariff.find('.tariff__switch');

            $switch.off('click', '.tariff__switch__option');
            $switch.on('click', '.tariff__switch__option', function() {
                var $option = $(this);
                var href = $option.data('href');
                var value = $option.data('value');
                var allValues = $option.parent().find('[data-value]').get().map(function(item) {return $(item).data('value')});
                var $tariff = $option.closest('.tariff');
                var $button = $tariff.find('.tariff__button');

                var $carousel = $tariff.closest('.owl-carousel');
                if ($carousel) {
                    var lable = $button.data('label');
                    $tariff = $carousel.find('[data-label=' + lable + ']').closest('.tariff');
                    $button = $tariff.find('.tariff__button');
                }

                $tariff.removeClass(allValues).addClass(value);
                $button.attr('href', fixHref(href, from));
            });

            $tariff.off('click', '.disko');
            $tariff.on('click', '.disko', function(event) {
                event.stopPropagation();
                event.preventDefault();
                window.open('https://disk-o.cloud/', '_blank');
            });
        }

        var $carousel = $('.owl-carousel');
        if ($carousel) {
            $carousel.on('refreshed.owl.carousel', function() {
                console.log($(this, '.tariff'));
                addListeners($(this, '.tariff'));
            })
        }
        addListeners($('.tariff'));
    })();
});

